<template>
  <div class="report" :style="reportStyle">
    <payments-report-filter
      ref="rf"
      @submit="onFilterSubmit"
    />
    <payments-report-table
      ref="rt"
      :height="height"
      @page-changed="onPageCanged"
      @page-size-changed="onPageCanged"
      @save-csv="onSaveCsv"
      @save-xls="onSaveXls"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import moment from 'moment'
import PaymentsReportFilter from './PaymentsReport/PaymentsReportFilter'
import PaymentsReportTable from './PaymentsReport/PaymentsReportTable'
import { isServer } from '@/mixins/helpers'

export default {
  name: 'PaymentsReport',
  components: { PaymentsReportTable, PaymentsReportFilter },
  data () {
    return {
      height: 500
    }
  },
  computed: {
    ...mapGetters({
      deviceInfo: 'device'
    }),
    ...mapFields({
      reportCsv: 'reports.paymentsReport.reportCsv',
      reportXls: 'reports.paymentsReport.reportXls'
    }),
    reportStyle () {
      let style = ''
      if (this.deviceInfo?.type === 'mobile' || this.deviceInfo?.type === 'tablet') {
        style += 'overflow: hidden; overflow-y: auto; max-height: calc(100svh - 80px);'
      }
      return style
    }
  },
  async mounted () {
    await this.fetchReportData()
    this.$nextTick(() => {
      this.$nextTick(() => {
        this.calcHeight()
      })
    })
    if (window) {
      window.addEventListener('resize', this.calcHeight)
    }
  },
  beforeDestroy () {
    if (window) {
      window.removeEventListener('resize', this.calcHeight)
    }
  },
  methods: {
    ...mapActions({
      fetchReportData: 'reports/paymentsReport/fetchReportData',
      fetchReportCsv: 'reports/paymentsReport/fetchReportCsv',
      fetchReportXls: 'reports/paymentsReport/fetchReportXls'
    }),
    async onFilterSubmit () {
      await this.fetchReportData()
      this.$nextTick(() => {
        this.calcHeight()
      })
    },
    async onPageCanged (page) {
      await this.fetchReportData()
      this.$nextTick(() => {
        this.calcHeight()
      })
    },
    calcHeight () {
      if (!isServer && window && this.deviceInfo?.type !== 'mobile') {
        const filter = this.$refs.rf?.$el
        const report = this.$refs.rt.$el
        const $navbar = document.querySelector('.navbar')
        const $tHeader = report.querySelector('.card-header')
        const $tHead = report.querySelector('.table thead')
        const $tPager = report.querySelector('.b-pagination')
        const filterHeight = filter?.clientHeight || 0
        const navbarHeight = $navbar?.clientHeight || 0
        const tHeaderHeight = $tHeader?.clientHeight || 0
        const tHeadHeight = $tHead?.clientHeight || 0
        const tPagerHeight = $tPager?.clientHeight || 0
        const windowHeight = window.innerHeight
        this.height = windowHeight - filterHeight - navbarHeight - tHeaderHeight - tHeadHeight - tPagerHeight - 55
        // debugger
      }
    },
    async onSaveCsv () {
      await this.fetchReportCsv()
      const k = moment().format('DDMMYYHHmmss')
      const filename = `payments-report-${k}.csv`
      const file = new Blob([this.reportCsv], { type: 'text/plain;charset=utf-8' })
      this.$nextTick(() => {
        this.reportCsv = null
      })
      if (window.navigator.msSaveOrOpenBlob) {
        // IE10+
        window.navigator.msSaveOrOpenBlob(file, filename)
      } else {
        // Others
        const a = document.createElement('a')
        const url = URL.createObjectURL(file)
        a.href = url
        a.download = filename
        document.body.appendChild(a)
        a.click()
        this.$nextTick(() => {
          document.body.removeChild(a)
          window.URL.revokeObjectURL(url)
        })
      }
    },
    async onSaveXls () {
      await this.fetchReportXls()
      const k = moment().format('DDMMYYHHmmss')
      const filename = `payments-report-${k}.xlsx`
      const file = new Blob([this.reportXls], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      this.$nextTick(() => {
        this.reportXls = null
      })
      if (window.navigator.msSaveOrOpenBlob) {
        // IE10+
        window.navigator.msSaveOrOpenBlob(file, filename)
      } else {
        // Others
        const a = document.createElement('a')
        const url = URL.createObjectURL(file)
        a.href = url
        a.download = filename
        document.body.appendChild(a)
        a.click()
        this.$nextTick(() => {
          document.body.removeChild(a)
          window.URL.revokeObjectURL(url)
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
